const STORAGE_KEY = 'sabhia-suporte-access'

export class SuporteService {
  static salvarAcesso(token: string): void {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, grantedAt: Date.now() }))
    }
  }

  static verificarAcesso(): string | null {
    if (typeof window === 'undefined') return null
    try {
      const data = localStorage.getItem(STORAGE_KEY)
      if (!data) return null
      return JSON.parse(data).token
    } catch {
      return null
    }
  }

  static removerAcesso(): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(STORAGE_KEY)
    }
  }

  static async verificarToken(token: string): Promise<boolean> {
    try {
      const response = await fetch('/api/suporte', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, action: 'verify' }),
      })
      const data = await response.json()
      return data.ok === true
    } catch {
      return false
    }
  }

  static async apiProxy(path: string) {
    const token = this.verificarAcesso()
    if (!token) throw new Error('Não autorizado')

    const response = await fetch('/api/suporte', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token, action: 'proxy', payload: { path } }),
    })
    
    if (!response.ok) {
      const errData = await response.json().catch(() => null)
      const errMsg = errData?.error || errData?.message || response.statusText || 'Erro desconhecido no banco'
      console.error('API Error details:', errData)
      throw new Error(`Erro na API: ${errMsg}`)
    }
    
    return response.json()
  }

  static async buscarClientes(query: string) {
    const cleanQuery = query.trim()
    // Sintaxe correta do PostgREST (sem aspas duplas internas que quebram o parser)
    const filterString = `nome.ilike.*${cleanQuery}*,email.ilike.*${cleanQuery}*`
    
    // Removido o "&order=created_at.desc" pois a coluna não existe no banco de produção
    const path = `/clientes?or=(${encodeURIComponent(filterString)})&limit=15`
    return this.apiProxy(path)
  }

  static async buscarLivrosDoCliente(clienteId: string | number) {
    // 1. Pega os pedidos do cliente
    const pedidos = await this.apiProxy(`/pedidos?select=id_pedido&id_cliente=eq.${clienteId}`)
    const idsPedido = pedidos.map((p: any) => p.id_pedido).filter(Boolean)
    
    if (idsPedido.length === 0) return []

    const inList = `(${idsPedido.map((id: string) => `"${id}"`).join(',')})`
    
    // 2. Pega os livros desses pedidos
    const livros = await this.apiProxy(`/livros?select=*&id_pedido=in.${encodeURIComponent(inList)}&order=id_livro.desc`)
    
    // 3. Pega as capas
    const capas = await this.apiProxy(`/capas_livros?select=id_pedido,imagem_capa,imagem_capa_png&id_pedido=in.${encodeURIComponent(inList)}`)
    const capasMap = Object.fromEntries(capas.map((c: any) => [c.id_pedido, c]))

    // Junta as informações
    return livros.map((l: any) => ({
      ...l,
      capa: capasMap[l.id_pedido] || null
    }))
  }
}